<template>
  <div>
    <FITModal ref="deleteAgentModal" reference="modal" :title="$t('osm.product.delete.header')" @click="deleteAgent">
      <div slot="body">
        <span v-html="$t('osm.agentInfo.deleteAgentConfirm', {agentEnglishName: selectedAgent.agentEnglishName, agentChineseName: selectedAgent.agentChineseName})"></span>
      </div>
    </FITModal>
    <b-row align-v="center">
      <b-col :cols="haveAction? 3 : 4">
        <b>{{$t('osm.agentInfo.agent')}} <span class="text-danger">*</span></b>
      </b-col>
      <b-col cols="2">
        <b>{{$t('osm.agentInfo.agentSplitRate')}} <span class="text-danger">*</span></b>
      </b-col>
      <b-col cols="1">
        <b>{{$t('osm.agentInfo.isActive')}}</b>
      </b-col>
      <b-col cols="1">
        <b>{{$t('osm.agentInfo.isServiceAgent')}}</b>
      </b-col>
      <b-col cols="2">
        <b>{{$t('osm.agentInfo.effectiveDate')}}</b>
      </b-col>
      <b-col cols="2">
        <b>{{$t('osm.agentInfo.expiryDate')}}</b>
      </b-col>
      <b-col cols="1" v-if="haveAction">
      </b-col>
    </b-row>
    <hr style="border-color:#000000">
    <template v-if="!displayOnly">
      <template v-for="(agent,index) in value">
        <b-row align-v="center">
          <b-col :cols="haveAction? 3 : 4">
            <FITAutoSearch :rule="{required:true}" @validation="setValidation(index,'agentID',$event)"  dest="option" v-bind="agentAutoSearchParams" :disabled="isNameDisabled(agent)" v-model="agentObjList[index]"></FITAutoSearch>
          </b-col>
          <b-col cols="2">
            <FITTextInput :rule="{required:true, decimal:true, maxValue:100}" @validation="setValidation(index,'agentSplitRate',$event)"  v-model="value[index].agentSplitRate" :disabled="agent.isActive === 'N' || allDisabled "></FITTextInput>
          </b-col>
          <b-col cols="1">
            <FITCheckbox :disabled="allDisabled || permissionLevel >3.5  || value[index].isServiceAgent == 'Y'" trueString="Y" falseString="N" v-model="value[index].isActive"></FITCheckbox>
          </b-col>
          <b-col cols="1">
            <FITCheckbox v-model="value[index].isServiceAgent " :disabled="allDisabled || value.length == 1 || agent.isServiceAgent == 'Y' " @input="onCheckServiceAgent($event,index)" trueString="Y" falseString="N"></FITCheckbox>
          </b-col>
          <b-col cols="2">
            <FITDatePicker v-model="value[index].effectiveDate" :disabled="allDisabled "></FITDatePicker>
          </b-col>
          <b-col cols="2">
            <FITDatePicker v-model="value[index].expiryDate" :disabled="allDisabled "></FITDatePicker>
          </b-col>
          <b-col cols="1" v-if="haveAction && index >0 && !allDisabled">
            <h5 @click="onClickDeleteAgent(agent,index)"><i class="fas fa-times-circle text-danger" style="cursor:pointer"></i></h5>
          </b-col>
        </b-row>
      </template>
      <b-row >
        <b-col cols="2" offset="3"  class="text-center">
          <hr class="m-0 p-0">
          <div class="pt-2" :class="{'text-danger': totalSplitRate != 100, 'text-success': totalSplitRate == 100}"><b><h5>{{$t('osm.agentInfo.totalSplitRate')}} {{totalSplitRate}}%</h5></b></div>
        </b-col>
         <b-col v-if=" totalSplitRate != 100" cols="2" class="text-danger">Total agent split rate must be equal to 100%</b-col>
      </b-row>
      <div class="text-center">
        <FITButton text="+" variant="warning" @click="addAgent" v-if="!allDisabled"></FITButton>
      </div>
    </template>
    <template v-else>
      <b-row align-v="center" v-for="(agent,index) in value">
        <b-col cols="4">
          <p>{{agent.agentEnglishName}} {{agent.agentChineseName}}</p>
        </b-col>
        <b-col cols="2">
          <p>{{agent.agentSplitRate}}%</p>
        </b-col>
        <b-col cols="1">
          <FITCheckbox :disabled="true" v-model="value[index].isActive" trueString="Y" falseString="N"></FITCheckbox>
        </b-col>
        <b-col cols="1">
          <FITCheckbox :disabled="true" v-model="value[index].isServiceAgent" trueString="Y" falseString="N"></FITCheckbox>
        </b-col>
        <b-col cols="2">
          <p>{{agent.effectiveDate | date}}</p>
        </b-col>
        <b-col cols="2">
          <p>{{agent.expiryDate | date}}</p>
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script type="text/javascript">
import { FITModal, FITFormCard, FITvSelect, FITTextInput, FITDatePicker, FITSelect, FITTextarea, FITAutoSearch, FITWorkflowFileUpload, FITCheckbox, FITCheckboxGroup, FITButton } from '@/components'
import Vue from 'vue'

export default {
  name: 'AssignAgent',
  props: {
    haveAction: {
      type: Boolean,
      default: false
    },
    disabledName: {
      type: Boolean,
      default: false
    },
    allDisabled: {
      type: Boolean,
      default: false
    },
    displayOnly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => [{
        agent: {
          agentID: -1,
          agentChineseName: '',
          agentEnglishName: '',
        },
        agentSplitRate: '',
        isActive: "Y",
        isServiceAgent: "Y",
        effectiveDate: '',
        expiryDate: ''
      }]
    }
  },
  computed: {

    permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    totalSplitRate() {
      var total = parseFloat(0);
      this.value.forEach((item) => {
        if (item.agentSplitRate && item.isActive === 'Y') {
          total += parseFloat(item.agentSplitRate);
        }
      })
      return total
    }
  },
  data() {
    return {
      selectedAgent: {
        agentEnglishName: 'N/A',
        agentChineseName: 'N/A'
      },
      agentObjList: [{
        agentID: -1,
        agentSplitRate: '',
        isActive: "Y",
        isServiceAgent: "Y",
        effectiveDate: '',
        expiryDate: ''
      }],
      agentAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'agent' }],
        showItems: ['englishFullname', 'chineseFullname', 'agentCode'],
      },
      // value: this.value,
      fields: [{
          key: 'agent',
          label: this.$t('osm.assignAgent.agent'),
          thClass: 'd-none'
        }, {
          key: 'agentSplitRate',
          label: this.$t('osm.assignAgent.agentSplitRate'),
          thClass: 'd-none'
        },
        {
          key: 'isActive',
          label: this.$t('osm.assignAgent.isActive'),
          thClass: 'd-none'
        },
        {
          key: 'isServiceAgent',
          label: this.$t('osm.assignAgent.isServiceAgent'),
          thClass: 'd-none'
        },
        {
          key: 'effectiveDate',
          label: this.$t('osm.assignAgent.effectiveDate'),
          thClass: 'd-none'
        },
        {
          key: 'expiryDate',
          label: this.$t('osm.assignAgent.expiryDate'),
          thClass: 'd-none'
        }
      ],
      validation:[
      { agentID:false, agentSplitRate:false },
      ]
    }
  },

  methods: {
    setValidation(index, key ,value ){
      // console.log(`${index}  ${key}  ${value}`)
      this.validation[index][key] = value;
      this.updateValidationResult();
    },
    updateValidationResult(){
        let state = true;
        for (var i = this.validation.length - 1; i >= 0; i--) {
            state = state && this.validation[i].agentID && this.validation[i].agentSplitRate;
        }
        state = state && (this.totalSplitRate == 100);

        this.$emit('validation', state);

        // updateToVuex
        this.$store.commit('Validation/setValidationResult', {
          object: 'default',
          field: 'policyAgent',
          result: state,
        });
    },
    onClickDeleteAgent(agent, index) {
      Vue.set(this, 'selectedAgent', agent);
      Vue.set(this.selectedAgent, 'index', index);
      if (this.selectedAgent.ID == null || this.selectedAgent.ID == 0) {
        this.value.splice(this.selectedAgent.index, 1);
        return;
      }
      this.$refs.deleteAgentModal.openModal();
    },
    deleteAgent(evt) {
      if (!evt) {
        return;
      }
      this.$store.dispatch('GIPolicy/deletePolicyAgent', this.selectedAgent.ID).then((json) => {
        this.value.splice(this.selectedAgent.index, 1);
      }, (err) => {})
    },
    isNameDisabled(input) {
      if (this.disabledName) {
        if (input.isExist) {
          return true
        }
      }
      if (this.allDisabled) {
        return true;
      }
      return false;
    },
    mapAgentObj() {
      let agentObjList = this.value.map((item) => {
        return { ID: item.agentID, chineseFullname: item.agentChineseName, englishFullname: item.agentEnglishName, agentCode: item.agentCode }
      })
      Vue.set(this, 'agentObjList', agentObjList);
      // console.debug(agentObjList);
    },
    setAgentID(id, index) {
      Vue.set(this.value[index], 'agentID', id);
    },
    convertAgentObj(agentID, chineseName, englishName) {
      console.debug(agentID, chineseName, englishName);
      return { ID: agentID, chineseFullname: chineseName, englishFullname: englishName }
    },
    onCheckServiceAgent(event, index) {
      if (event === 'Y') {
        Vue.set(this.value[index], 'isActive', event);
        this.value.forEach((item, idx) => {
          if (index != idx) {
            Vue.set(this.value[idx], 'isServiceAgent', 'N');
          }
        })
      }
    },
    addAgent() {
      this.value.push({
        agentID: -1,
        agentSplitRate: '',
        isActive: "N",
        isServiceAgent: "N",
        effectiveDate: '',
        expiryDate: '',
        agentCode: '',
        agentChineseName: '',
        agentEnglishName: ''
      })
      this.validation.push({agentID:false, agentSplitRate:false});

    }
  },
  watch: {
    agentObjList: {
      handler(newData, oldData) {
        newData.forEach((item, index) => {
          Vue.set(this.value[index], 'agentID', item.ID);
          Vue.set(this.value[index], 'agentCode', item.agentCode);
          Vue.set(this.value[index], 'agentChineseName', item.chineseFullname);
          Vue.set(this.value[index], 'agentEnglishName', item.englishFullname);
        })
      }
    },
    value(newData, oldData) {
      this.mapAgentObj();
    }
  },
  components: {
    FITFormCard,
    FITvSelect,
    FITTextInput,
    FITDatePicker,
    FITSelect,
    FITTextarea,
    FITAutoSearch,
    FITWorkflowFileUpload,
    FITCheckbox,
    FITCheckboxGroup,
    FITButton,
    FITModal
  },
}

</script>
<style type="text/css">


</style>



// WEBPACK FOOTER //
// src/Osm/components/AssignAgent.vue